export function getInitials(name: string | null, email: string | null): string {
	if (name) {
		const parts = name.trim().split(/\s+/);
		const first = parts[0]?.charAt(0) ?? "";
		const last = parts.length > 1 ? (parts.at(-1)?.charAt(0) ?? "") : "";
		return (first + last).toUpperCase() || "?";
	}
	if (email) return email.charAt(0).toUpperCase();
	return "?";
}
